import { EvaChartStates } from "types/factory";

import { DataEnum } from "models";

import { convertToNumber } from "./utils/convertToNumber";

/**
 * Well Status vs Time (product: "Add locks for y-axis"): user
 * locks on the single count axis.
 *
 * There are NO x locks and no second axis. The x-axis is a category axis of
 * server-computed time buckets whose window the time-scale / custom-range
 * selector owns, and this chart draws one stacked metric, so `y2` is left
 * undefined for the shared `createChartLocks` shape. Only the user's explicit
 * min/max pass through; everything else stays undefined so the translator falls
 * back to letting ECharts pick the bounds.
 *
 * Same rules as `rigFracActivityLocks`, minus the secondary axis — deliberately
 * a separate module rather than a re-export, because the two charts' axis
 * inventories differ and a shared one would quietly grant this chart y2 locks
 * it has no axis for.
 */
export function wellStatusLocks(states: Partial<EvaChartStates>) {
  const { locks } = states;

  // A "Reset" type means the user cleared the lock; an undefined value means it
  // was never set. Neither is a lock the translator should honour.
  const isUserLock = (lock: Maybe<{ type?: string; value?: unknown }>) =>
    lock?.type !== DataEnum.Reset && lock?.value !== undefined;

  const isUserYMinLock = isUserLock(locks?.yMin);
  const isUserYMaxLock = isUserLock(locks?.yMax);

  return {
    lockedXMin: undefined,
    lockedXMax: undefined,
    lockedYMin: convertToNumber(isUserYMinLock ? locks?.yMin?.value : undefined),
    lockedYMax: convertToNumber(isUserYMaxLock ? locks?.yMax?.value : undefined),
    lockedYMinType: isUserYMinLock ? locks?.yMin?.type : undefined,
    lockedYMaxType: isUserYMaxLock ? locks?.yMax?.type : undefined
  };
}
